import {AfterViewChecked, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {DateService} from "../../../core/date.service";
import {GAService} from "../../../root/ga/ga.service";
import {SessionService} from "../../../core/session.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'booking-filter',
    templateUrl: './booking-filter.component.html',
    providers: [DateService, GAService]
})
export class BookingFilterComponent implements OnInit, AfterViewChecked {

    @Input() data:any;
    @Input() landing:any;
    @Output() filter:EventEmitter<any> = new EventEmitter<any>();
    @Output() pointsOfSale:EventEmitter<any> = new EventEmitter<any>();
    @Output() autocompleteCompany:EventEmitter<any> = new EventEmitter<any>();
    @Output() autocompleteCities:EventEmitter<any> = new EventEmitter<any>();

    model:any = {};
    removeFilters:boolean = false;

    currentDate;
    tomorrow;
    disableApplyFilters:boolean = false;
    textRange:string = "";
    constructor(private dateService: DateService, private sessionService: SessionService,
                public gaService:GAService, private translator: TranslateService,
                private cdRef:ChangeDetectorRef) {
    }

    defaultFilter: any;
    dateFrom;
    dateTo;
    userType;
    despegarFilters;

    hideDespegarFilters(){
        if(!!this.sessionService.getUserSession()){
            if(this.sessionService.getUserSession().userType == "DESPEGAR"){
                this.despegarFilters = true;
                return false;
            }else{
                this.disablePointsOfSale = false;
                return true;
            }
        }
    }

    @ViewChild('companyName') companyName: ElementRef;
    @ViewChild('rangeType') rangeType: ElementRef;
    @ViewChild('selectDateRange') selectDateRange: ElementRef;
    @ViewChild('testCheck') testCheck: ElementRef;
    @ViewChild('companyOid') companyOid: ElementRef;
    @ViewChild('pickupCity') pickupCity: ElementRef;
    @ViewChild('dropoffCity') dropoffCity: ElementRef;
    @ViewChild('pointOfSale') pointOfSale: ElementRef;
    @ViewChild('bookingOid') bookingOid: ElementRef;
    @ViewChild('fenixOid') fenixOid: ElementRef;

    ngAfterViewChecked(): void {
        this.advancedFilters = document.querySelectorAll(".default-filters [filter-id]").length;
        if(this.despegarFilters){
            this.advancedFilters = this.advancedFilters + document.querySelectorAll(".despegar-filters [filter-id]").length;
        }
/*
        if(this.landing.valid){
            this.dateTypeSelect = this.landing.dateType;
            this.disableDatepicker = false;
            this.validateTypeDateRangeSelect(this.landing.dateType);
            this.periodRange.from = false;
        }*/
        this.cdRef.detectChanges();
    }

    ngOnInit() {
        this.currentDate = new Date();
        this.tomorrow = new Date(this.currentDate);
        this.advancedFilters = document.querySelectorAll(".default-filters [filter-id]").length;
        this.defaultFilter= {
            'sSortDir_0':'asc',
            'dateType':'PICK_UP',
            'period.from': this.dateService.formatDateToYYYYMMDD(this.currentDate),
            'period.to': this.dateService.formatDateToYYYYMMDD(this.currentDate),
            'filterId':'TODAY',
            'sortingColumnName': 'PICKUP_DATE'
        };
    }

    showAdvancedFilters(event){
        if(event.detail){
            this.sendGa("Ver_filtros_avanzados", "Ver filtros avanzados");
        }
    }

    searchCompany(event){
        this.companyOid.nativeElement.value = "";
        this.autocompleteCompany.next(event.detail)
    }

    searchCities(event){
        this.autocompleteCities.next(event.detail)
    }

    advancedFilters;
    periodRange: any = this.resetPeriodRange();
    validRange:any = this.resetPeriodRange();

    getCompanyOidByName(event){
        if(event.detail != null && event.detail != ""){
            this.disablePointsOfSale = false;
            this.pointsOfSale.next(event.detail);
        }
        if(event.detail == ""){
            this.disablePointsOfSale = true;
            this.pointOfSale.nativeElement.value = '';
        }
    }

    getCompanyOidById(event){
        let value = event.target.value;
        if(value != null && value != ""){
            this.disablePointsOfSale = false;
            this.companyName.nativeElement.value = "";
            this.pointsOfSale.next(value);
        }
        if(value == ""){
            this.disablePointsOfSale = true;
            this.pointOfSale.nativeElement.value = '';
        }
    }

    applyTestFilter(event){
        if(event.detail){
            this.model["test"] = true;
        }else{
            delete this.model["test"];
        }
    }

    appliedFilters(event){
        if(this.model["dateType"]){
            for (var i in this.model){
                if(i != "dateType" && i != "period.from" && i != "period.to"){
                    delete this.model[i];
                }
            }
        }
        var filters = event.detail;
        this.buildFilterRequest(filters);

        if((Object.keys(this.model).length > 0)){
            this.model.filterId = 'FILTERED';
            this.model.sortingColumnName = 'PICKUP_DATE';
            this.filter.next(this.model);
        }else{
           this.filter.next(this.defaultFilter);
        }
    }
    disableDatepicker: boolean = true;
    disablePointsOfSale: boolean = true;
    isSelected:boolean = true;
    dateTypeSelect;
    rangeTypeSelect;

    changeTypeDateSelectValue(event){
        let value = event.target.value;
        this.validateTypeDateRangeSelect(value);
    }

    validateTypeDateRangeSelect(value){
        if(value == "empty"){
            this.rangeTypeSelect = "";
            this.disableDatepicker = true;
            delete this.model["dateType"];
            delete this.model["period.from"];
            delete this.model["period.to"];
        }else{
            this.disableDatepicker = false;
            this.model["dateType"] = value;
        }
        if (this.disableDatepicker){
            let from = document.querySelector("#from")["value"];
            let to = document.querySelector("#to")["value"];
            if(from != undefined && from != null){
                document.querySelector("#from")["value"]= null;
            }
            if(to != undefined && to != null){
                document.querySelector("#to")["value"]= null;
            }
            this.disableApplyFilters = false;
            this.periodRange.from = false;
            this.periodRange.to = false;
        }else{
            this.periodRange.from = true;
            this.periodRange.to = true;
            this.disableApplyFilters = true;
        }
    }

    validateDateRange(event){
        this.periodRange.from = false;
    }

    checkDateToValue(event){
        if (event.target.value != null){
            let from = document.querySelector("#from")["value"];
            this.periodRange.from = false;
            if(event.target.value != "" && from != null){
                this.dateTo = event.target.value;
                if(typeof this.dateTo == "string"){
                    this.dateTo = this.formatStringWithChar(this.dateTo);
                    this.dateFrom = from;
                }
                this.disableApplyFilters = false;
                this.textRange = from;
                this.parseDate();
                this.rangeType.nativeElement.value = this.dateService.formatToString(this.dateFrom) + this.translator.instant('booking.common.to') + this.dateService.formatToString(this.dateTo);
            }
        }
    }

    parseDate(){
        this.model["period.from"] = this.dateService.formatDateToYYYYMMDD(this.dateFrom);
        this.model["period.to"] = this.dateService.formatDateToYYYYMMDD(this.dateTo);
    }

    formatStringWithChar(dateString){
        var day = dateString.substring(8, 10);
        var month = dateString.substring(5, 7);
        var year = dateString.substring(0, 4);

        var date = new Date(year, month-1, day);

        return date;
    }

    sendGa(action, arg){
        this.gaService.notify("Autos_listado_de_reservas", action, [arg]);
    }

    removedFilter(event){
        let filterToBeRemoved = event.detail.elem.attributes["name"].value;
        this.sendGa("Eliminar_filtro", filterToBeRemoved);
        if(this.model["dateType"] && filterToBeRemoved == "Tipo de fecha"){
            this.removeDateType();
        }else{
            delete this.model[event.detail.tagId];
        }
        if ((Object.keys(this.model).length <= 2) &&  this.model.filterId == "FILTERED"){
            this.model = {};
            this.filter.next(this.defaultFilter);
        }else{
            this.filter.next(this.model);
        }
    }

    resetPeriodRange(){
        return {from: false, to: false};
    }

    removedFilters(ev){
        this.model = {};
        this.dateTypeSelect = "empty";
        this.disablePointsOfSale = true;
        this.validateTypeDateRangeSelect(this.dateTypeSelect);
        this.periodRange = this.resetPeriodRange();
        this.validRange = this.resetPeriodRange();
        this.disableApplyFilters = false;
        this.filter.next(this.defaultFilter);
    }

    removeDateType(){
        if(this.model["dateType"]){
            delete this.model["dateType"];
            delete this.model["period.from"];
            delete this.model["period.to"];
        }
        this.dateTypeSelect = "empty";
        this.validateTypeDateRangeSelect(this.dateTypeSelect);
    }

    //si es companyName, hacer el request con companyOid
    private buildFilterRequest(filters) {
        [].forEach.call(filters,(value) => {
            var gaTag = "bookingList.analytics." + value.tagId;
            this.translator.getTranslation("es").subscribe((translationObj) => {
                this.sendGa("Filtrar", translationObj[gaTag]);
            });
            if (value.tagId != null){
                this.model[value.tagId] = value.value;
            }
        });
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/booking/filter/booking-filter.component.ts